import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup, ValidatorFn } from '@angular/forms';

@Directive({
    selector: '[appMustBeLesserThan]',
    providers: [{ provide: NG_VALIDATORS, useExisting: AppMustBeLesserThanDirective, multi: true }]
})
export class AppMustBeLesserThanDirective implements Validator {
    @Input('appMustBeLesserThan')
    appMustBeLesserThan: string[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        return MustBeLesserThan(this.appMustBeLesserThan[0], this.appMustBeLesserThan[1])(formGroup);
    }
}

export function MustBeLesserThan(controlName: string, matchingControlName: string): ValidatorFn {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        // return null if controls haven't initialised yet
        if (!control || !matchingControl || isNaN(control.value) || isNaN(matchingControl.value)) {
          return null;
        }

        // return null if another validator has already found an error on the matchingControl
        if (matchingControl.errors && !matchingControl.errors.mustBeLesserThan) {
            return null;
        }

        // set error on matchingControl if validation fails
        if (Number(control.value) < Number(matchingControl.value)) {
            matchingControl.setErrors(null);
        } else {
            matchingControl.setErrors({ mustBeLesserThan: true });
        }
    };
}
